<template>
    <div class="terms-of-use-container" v-html="termsOfUseContent"></div>
  </template>
  
  <script>
  export default {
    name: 'TermsOfUsePage',
    data() {
      return {
        termsOfUseContent: ''
      }
    },
    async mounted() {
      try {
        const response = await fetch('/terms-of-use.html')
        this.termsOfUseContent = await response.text()
      } catch (error) {
        console.error('Error loading terms of use:', error)
      }
    }
  }
  </script>
  
  <style scoped>
  .terms-of-use-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    font-family: 'Arial', sans-serif;
  }
  </style>
  